"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const numeral_1 = __importDefault(require("numeral"));
const config_1 = require("../../config/config");
const GamesList_1 = require("./GamesList");
class Game {
    constructor(data) {
        this.getTopPrize = () => {
            if (this.topPrizeHumanReadable) {
                return this.topPrizeHumanReadable;
            }
            return this.formatTopPrize();
        };
        this.formatTopPrize = () => (0, numeral_1.default)(this.topPrize).format(config_1.react_core_config.internalConfig.currencyFormat);
        this.id = data.id;
        this.gameId = data.gameId;
        this.name = data.name;
        this.playBegin = data.playBegin;
        this.playEnd = data.playEnd;
        this.playExpiry = data.playExpiry;
        this.lastModifiedDate = data.lastModifiedDate;
        this.lotteryId = data.lotteryId;
        this.description = data.description;
        this.retailPrice = data.retailPrice;
        this.topPrize = data.topPrize;
        this.topPrizeHumanReadable = data.topPrizeHumanReadable;
        this.ticketPosImage = data.ticketPosImage;
        this.ticketFullImage = data.ticketFullImage;
        this.logo = data.logo;
        this.ticketFullImageMobile = data.ticketFullImageMobile;
        this.ticketScratchedImage = data.ticketScratchedImage;
        this.state = data.state;
        this.progress = data.progress;
        this.overallOdds = data.overallOdds;
        this.gameProviders = data.gameProviders;
        this.gameTypeId = data.gameTypeId;
        this.topPrizeType = data.topPrizeType;
        this.tags = data.tags;
        this.externalLink = data.externalLink;
        this.primaryColor = data.primaryColor;
        this.secondaryColor = data.secondaryColor;
        this.currency = data.currency;
        this.vendor = data.vendor;
        this.retailPriceMin = data.retailPriceMin;
        this.retailPriceMax = data.retailPriceMax;
        this.playForFun = data.playForFun;
        this.isActive = !data.playEnd || (0, moment_timezone_1.default)().diff((0, moment_timezone_1.default)(data.playEnd)) < 0;
        this.howToPlay = data.howToPlay;
        this.displayOrder = data.displayOrder;
        this.contentUrl = data.contentUrl;
        this.resultData = data.resultData;
        this.nextJackpotResult = data.nextJackpotResult;
        this.jackpotResults = data.jackpotResults;
        this.latestJackpotResult = data.latestJackpotResult;
        this.jackpotGames = data.jackpotGames;
        this.rulesDocumentsList = data.rulesDocumentsList;
    }
}
exports.Game = Game;
Game.JsonToGames = (data) => {
    const gamesList = new GamesList_1.GamesList();
    data.forEach(game => gamesList.push(Game.JsonToGame(game)));
    return gamesList.getDateStartSorted();
};
Game.JsonToGame = (data) => new Game(data);
Game.JsonToRelatedGames = (data) => {
    const gamesList = [];
    data.forEach(game => gamesList.push(Game.JsonToGame(game)));
    return gamesList;
};
//# sourceMappingURL=Game.js.map